<template>
  <div class="cloud-center">
    <!-- 轮播图 -->
    <div v-if="!this.$route.meta.isSwiper" class="swiper">
      <Swiper boxHeight='120px' />
    </div>

    <div v-if="!this.$route.meta.isSecondaryNav" class="nav-bar-box">
      <div class="nav-bar">
        <el-radio-group class="nav-bar-list" v-model="navBarRoute">
          <el-radio class="nav-bar-item" label="/cloud-class/demand-room">点播课堂</el-radio>
          <el-radio class="nav-bar-item" label="/cloud-class/interactive-room">1+N互动课堂</el-radio>
          <el-radio class="nav-bar-item" label="/cloud-class/live-room">直播课堂</el-radio>
        </el-radio-group>
        <div>
        </div>
      </div>
    </div>

    <!-- 显示子路由 -->
    <router-view />

  </div>
</template>

<script>
// 轮播图
import Swiper from "@/components/content/Swiper";

export default {
  name: "cloudClassCenter",
  components: {
    Swiper
  },
  data() {
    return {
      //当前路由路径
      navBarRoute: this.$route.path
    };
  },

  watch: {
    //点击跳转子路由
    navBarRoute(newVal) {
      this.$router.push(newVal);
    }
  }
};
</script>

<style lang="less" scoped>
//激活时和悬浮时字体颜色
@acitveColor: #24ba58;
//字体基础颜色
@fontColor: #333;

.cloud-center {
  .nav-bar-box {
    display: flex;

    height: 40px;

    background-color: #fff;

    box-shadow: 0 0 5px 1px #ccc;

    justify-content: center;

    .nav-bar {
      display: flex;

      min-width: 1200px;

      font-size: 14px;
      font-weight: 400;

      color: @fontColor;

      align-items: center;
      justify-content: space-between;

      .nav-bar-list {
        /deep/ .el-radio__input {
          display: none;
        }

        /deep/ .el-radio__label {
          margin-left: 20px;
          padding-left: 0;

          font-weight: 400;

          color: @fontColor;
        }

        /deep/ .el-radio__label:hover {
          color: @acitveColor;
        }

        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: @acitveColor;
        }
      }
    }
  }
}
</style>